import styled, { createGlobalStyle } from 'styled-components';

interface PackageCareIndicationContainerProps {
  $shouldNotDisplayCareStatus: boolean;
  $mapView?: boolean;
  $rowDisplay?: boolean;
  $isNoCareProgram?: boolean;
  $isSelected?: boolean;
  $backgroundColor?: string;
}

export const PackageCareIndicationContainer = styled.div<PackageCareIndicationContainerProps>`
  display: flex;
  align-items: center;
  background: ${({ $mapView, $backgroundColor, theme: { token } }) =>
    $mapView ? $backgroundColor : token.colorBgElevated};
  border-top-right-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  border-bottom-right-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;

  padding: ${({ theme: { token } }) => token.paddingXS}px
    ${({ theme: { token }, $mapView }) => ($mapView ? token.paddingXS : token.padding)}px;
  width: fit-content;
  box-shadow: ${({ $mapView, theme: { token } }) => ($mapView ? 'unset' : token.boxShadowSecondary)};
  cursor: default;
  ${({ $shouldNotDisplayCareStatus }) => $shouldNotDisplayCareStatus && ` visibility: hidden; `}
  ${({ $mapView, theme: { token } }) => ($mapView ? `border-radius: ${token.borderRadiusLG}px;` : `height: 50px;`)}

  &:hover {
    background: ${({ theme: { token } }) => token.colorBgContainer};
  }

  ${({ $isNoCareProgram, $mapView, theme: { token } }) =>
    $isNoCareProgram && `gap: 6px; ${$mapView && `box-shadow: unset; border-radius: ${token.borderRadiusLG}px; }`}`}

  .text-container {
    display: flex;
    flex-direction: ${({ $mapView }) => ($mapView ? 'row' : 'column')};
    justify-content: center;
    color: ${({ theme: { token } }) => token.colorText};
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
    ${({ $mapView }) => $mapView && `gap: 2px; flex-wrap: wrap; justify-content: flex-start;`}
  }

  .plan-text {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    ${({ $mapView, theme: { token } }) => $mapView && `line-height: ${token.fontSize}px;`}
  }

  .care-text {
    display: flex;
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    ${({ $mapView, theme: { token } }) => $mapView && `line-height: ${token.fontSize}px;`}
  }

  .tm-text {
    font-size: 0.3rem;
    ${({ $mapView }) => $mapView && `line-height: 0.3rem;`}
  }

  .no-care-text {
    color: ${({ theme: { token } }) => token.colorTextDisabled};
  }
`;

export const PackageCareIndicationTooltipGlobalStyle = createGlobalStyle`
  .package-care-tooltip {
    max-width: unset;
  }
`;
